<template>
  <div
    class="ll-display-export-card"
    :class="{'big-title':C_bigTitle}"
  >
    <div
      v-if="bigTitle"
      class="ll-display-export-card_title"
    >
      {{ $t(C_bigTitle) }}
    </div>
    <div
      class="ll-display-export-card_content-wrap"
      @click="onClick()"
    >
      <div class="ll-display-export-card__title-wrap">
        <p class="ll-display-export-card__title">
          {{ $t(title) }}
        </p>
        <ContentChip
          v-if="_threeMonthTag"
          yellow
          :text-label="_threeMonthTag"
        />
        <ContentChip
          v-else-if="_sixMonthTag"
          yellow
          :text-label="_sixMonthTag"
        />
      </div>
      <div class="ll-display-export-card__content">
        <div class="ll-display-export-card__content-list">
          <ContentChipsList :chips="systemSubclasses" />
          <p class="ll-display-export-card__content-text">
            {{ $t(dateTitle) }} {{ date }}
          </p>
          <p class="ll-display-export-card__content-text">
            {{ $t(type) }}
          </p>
        </div>
        <!-- <div class="ll-display-export-card__content-btns">
          <WsTextButton001
            primary
            no-padding
            font-size-lg
            leading-icon="icon-cloud-download"
            @click="exportPdfClick()"
          >
            匯出 PDF
          </WsTextButton001>
          <WsTextButton001
            primary
            no-padding
            font-size-lg
            leading-icon="icon-cloud-download"
            @click="exportExcelClick()"
          >
            匯出 xlsx
          </WsTextButton001>
        </div> -->
        <WsChips001
          v-if="tags.length > 0"
          :value="tags"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LlDisplayExportCard",
  props: {
    bigTitle: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    systemSubclasses: {
      type: Array,
      default() {
        return [];
      },
    },
    date: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    updateAt: {
      type: String,
      default: "",
    },
    dateTitle: {
      type: String,
      default: "生效日",
    },
    tags: {
      type: Array,
    },
  },
  data: () => ({
    C_bigTitle: "",
  }),
  computed: {
    _threeMonthTag() {
      let updateChip = this.$_getLawBadgeByUpdateDate(this.updateAt, 3);
      return updateChip;
    },
    _sixMonthTag() {
      let updateChip = this.$_getLawBadgeByUpdateDate(this.updateAt, 6);
      return updateChip;
    },
  },
  watch: {
    bigTitle: {
      deep: true,
      handler() {
        this.C_bigTitle = this.bigTitle;
      },
    },
  },
  mounted() {
    this.C_bigTitle = this.bigTitle;
  },
  methods: {
    $_getLawBadgeByUpdateDate(date, months) {
      const today = new Date();
      const newDate = this.$moment(today);
      const secondDate = this.$moment(date);
      if (
        newDate.diff(secondDate, "months", true) <= months &&
        newDate.diff(secondDate, "months", true) > 0
      ) {
        return months === 3
          ? this.$t('近{number}個月異動', {number: 3})
          : this.$t('近{number}個月異動', {number: 6});
      } else {
        return "";
      }
    },
    exportPdfClick() {
      console.log("pdf");
      this.$emit("pdf-click");
    },
    exportExcelClick() {
      console.log("excel");
      this.$emit("excel-click");
    },
    onClick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-display-export-card";
</style>